<div class="makePaymentPage__tableRow row flex-column flex-lg-row my-3 py-4">
  <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex">
    <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.status' | cxTranslate }}: </div>
    <div class="d-flex align-items-center">
      {{
        ['makeAPayment.confirmationStep.transactionStatus__processing', 'makeAPayment.confirmationStep.transactionStatus__unknown'] |
          cxTranslate: {context: status()?.toLowerCase()}
      }}
    </div>
  </div>


  <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex">
    <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.invoice#' | cxTranslate }}: </div>

    <a href="javascript: void(0);" class="underline" (click)="invoicePdf(id())">{{ id() }}</a>
  </div>

  <div class="makePaymentPage__tableCell col-12 col-lg-2 d-flex">
    <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.payment_date' | cxTranslate }}: </div>
    <span>{{ CommonUtils.formatDate(date(), US_DATE_FORMAT, EU_DATE_FORMAT) }}</span>
  </div>

  <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
    <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.payment_method' | cxTranslate }}: </div>
    @if (invoiceItemForPaymentMethod()) {
      <sanofi-payment-method [paymentInfo]="invoiceItemForPaymentMethod()"/>
    } @else {
      {{ 'makeAPayment.creditPaymentMethod' | cxTranslate }}
    }
  </div>

  <div class="makePaymentPage__tableCell col-12 col-lg-3 d-flex">
    <div class="makePaymentPage__tableHeaderCell d-lg-none mr-3 my-2">{{ 'makeAPayment.payment_amount' | cxTranslate }}: </div>
    <span>{{ amount() | currency }}</span>
  </div>
</div>
